"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var downshift_1 = require("downshift");
var lodash_debounce_1 = __importDefault(require("lodash.debounce"));
var react_1 = require("react");
var useGetSuggestionHref_1 = __importDefault(require("./useGetSuggestionHref"));
var useSearchBarEvents_1 = __importDefault(require("./useSearchBarEvents"));
var useSuggestions_1 = __importDefault(require("./useSuggestions"));
var constants_1 = require("../constants");
var SearchBarContext_1 = __importDefault(require("../SearchBarContext"));
var suggestions_1 = require("../suggestions");
var utils_1 = require("../utils");
function useSearchBar() {
    var _this = this;
    var _a = (0, react_1.useContext)(SearchBarContext_1.default), customEventData = _a.customEventData, displayInputValue = _a.displayInputValue, setDisplayInputValue = _a.setDisplayInputValue, setSuggestionQuery = _a.setSuggestionQuery, suggestionQuery = _a.suggestionQuery, onSuggestionSelection = _a.onSuggestionSelection, trackEvent = _a.trackEvent, onCloseModal = _a.onCloseModal, noResultsQuery = _a.noResultsQuery;
    var getSuggestionUrl = (0, useGetSuggestionHref_1.default)();
    var searchBarEvents = (0, useSearchBarEvents_1.default)(trackEvent);
    var _b = (0, react_1.useState)(false), pressedEnter = _b[0], setPressedEnter = _b[1];
    var _c = (0, useSuggestions_1.default)(), setRecentSearches = _c.setRecentSearches, setKeyPressed = _c.setKeyPressed, suggestionResults = _c.suggestionResults, suggestionsLength = _c.suggestionsLength, suggestedSearchesLoading = _c.suggestedSearchesLoading;
    var _d = (0, react_1.useState)(-1), highlightedIndex = _d[0], setHighlightedIndex = _d[1];
    var hasInput = displayInputValue.length > 0;
    var _e = (0, downshift_1.useCombobox)({
        id: 'merch-search-bar',
        items: suggestionResults
    }), closeMenu = _e.closeMenu, isOpen = _e.isOpen, getMenuProps = _e.getMenuProps, getInputProps = _e.getInputProps, getItemProps = _e.getItemProps;
    var getSuggestionEventData = (0, react_1.useCallback)(function (suggestion) { return (__assign(__assign({}, customEventData), { buildKey: 'buildKey' in suggestion ? suggestion.buildKey : null, suggestionIndex: 'suggestionIndex' in suggestion ? suggestion.suggestionIndex : null, suggestionsLength: suggestionsLength, suggestionText: suggestion.text, textEntered: displayInputValue, textSource: 'searchType' in suggestion ? suggestion.searchType : null })); }, [customEventData, displayInputValue, suggestionsLength]);
    var handleResetMenu = (0, react_1.useCallback)(function (text) {
        closeMenu();
        setHighlightedIndex(-1);
        setDisplayInputValue(text);
        // Close modal async to avoid any default scroll events while the modal is closing on iOS
        setTimeout(function () { return onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal(text); }, 0);
    }, [closeMenu, onCloseModal, setDisplayInputValue]);
    var handleDefaultSuggestionClicked = (0, react_1.useCallback)(function (e, suggestionText) {
        handleResetMenu(suggestionText);
    }, [handleResetMenu]);
    var handleSuggestionSelection = (0, react_1.useCallback)(function (suggestion, eventData) {
        var href = suggestion.href, searchHash = suggestion.searchHash, text = suggestion.text;
        var suggestionUrl = href ? getSuggestionUrl(href, eventData) : '';
        handleResetMenu(text);
        if (onSuggestionSelection) {
            onSuggestionSelection({
                cvnaId: searchHash !== null && searchHash !== void 0 ? searchHash : '',
                url: suggestionUrl,
                eventData: eventData
            });
            return;
        }
        if (suggestionUrl) {
            window.location.href = suggestionUrl;
        }
    }, [getSuggestionUrl, handleResetMenu, onSuggestionSelection]);
    var handleInputOnFocus = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
        setSuggestionQuery(e.target.value);
        searchBarEvents.focused();
    }, [searchBarEvents, setSuggestionQuery]);
    var debouncedSetSuggestionQuery = (0, react_1.useMemo)(function () { return (0, lodash_debounce_1.default)(setSuggestionQuery, 250, { leading: true }); }, [setSuggestionQuery]);
    var handleInputOnChange = (0, react_1.useCallback)(function (e) { return __awaiter(_this, void 0, void 0, function () {
        var newInputValue;
        return __generator(this, function (_a) {
            newInputValue = e.currentTarget.value;
            setDisplayInputValue(newInputValue);
            debouncedSetSuggestionQuery(newInputValue);
            return [2 /*return*/];
        });
    }); }, [debouncedSetSuggestionQuery, setDisplayInputValue]);
    var handleClearText = (0, react_1.useCallback)(function () {
        setDisplayInputValue('');
        setSuggestionQuery('');
    }, [setDisplayInputValue, setSuggestionQuery]);
    var highlightedSuggestion = suggestionResults[highlightedIndex];
    var handleRemoveRecentSearch = (0, react_1.useCallback)(function (e) {
        var _a;
        e.preventDefault();
        e.stopPropagation();
        searchBarEvents.removeRecentSearch();
        var value = e.currentTarget.value;
        if ((_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.value) {
            setRecentSearches((0, suggestions_1.removeSuggestionFromLocalStorage)(value, displayInputValue));
        }
    }, [displayInputValue, searchBarEvents, setRecentSearches]);
    var handleGoButtonClick = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
        var suggestion = highlightedSuggestion || suggestionResults[0] || constants_1.noSelectedSuggestion;
        // Save Suggested Search to Local Storage
        if (suggestion.searchType === constants_1.SearchType.TextSearch) {
            setRecentSearches((0, suggestions_1.saveSuggestionToLocalStorage)(suggestion));
        }
        var eventData = getSuggestionEventData(suggestion);
        searchBarEvents.goClicked(eventData);
        handleSuggestionSelection((0, utils_1.normalizeSuggestionSelection)(suggestion), eventData);
    }, [
        getSuggestionEventData,
        handleSuggestionSelection,
        highlightedSuggestion,
        searchBarEvents,
        setRecentSearches,
        suggestionResults
    ]);
    var handleSuggestionClick = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
        if (!highlightedSuggestion)
            return;
        var suggestion = highlightedSuggestion;
        // Save Suggested Search to Local Storage
        if (suggestion.searchType === constants_1.SearchType.TextSearch) {
            setRecentSearches((0, suggestions_1.saveSuggestionToLocalStorage)(suggestion));
        }
        var eventData = getSuggestionEventData(suggestion);
        searchBarEvents.suggestionClicked(eventData);
        handleSuggestionSelection((0, utils_1.normalizeSuggestionSelection)(suggestion), eventData);
    }, [
        getSuggestionEventData,
        handleSuggestionSelection,
        highlightedSuggestion,
        searchBarEvents,
        setRecentSearches
    ]);
    (0, react_1.useEffect)(function () {
        if (noResultsQuery) {
            setHighlightedIndex(-1);
        }
    }, [noResultsQuery]);
    (0, react_1.useEffect)(function () {
        if (suggestionQuery) {
            setHighlightedIndex(function (prevIndex) { return (prevIndex > -1 ? prevIndex : 0); });
        }
        else {
            setHighlightedIndex(-1);
        }
    }, [suggestionQuery]);
    (0, react_1.useEffect)(function () {
        if (suggestedSearchesLoading || !pressedEnter)
            return;
        var suggestion = highlightedSuggestion || constants_1.noSelectedSuggestion;
        // Save Suggested Search to Local Storage
        if (suggestion.searchType === constants_1.SearchType.TextSearch) {
            setRecentSearches((0, suggestions_1.saveSuggestionToLocalStorage)(suggestion));
        }
        var eventData = getSuggestionEventData(suggestion);
        searchBarEvents.suggestionClicked(eventData);
        handleSuggestionSelection((0, utils_1.normalizeSuggestionSelection)(suggestion), eventData);
        setPressedEnter(false);
    }, [
        getSuggestionEventData,
        handleSuggestionSelection,
        highlightedSuggestion,
        pressedEnter,
        searchBarEvents,
        setRecentSearches,
        suggestedSearchesLoading
    ]);
    var handleKeyDown = (0, react_1.useCallback)(function (e) {
        var _a, _b;
        var currentSelection;
        setKeyPressed(e.key);
        switch (e.key) {
            case 'Backspace':
                if (displayInputValue.length <= 1) {
                    return;
                }
                setPressedEnter(false);
                break;
            case 'Enter':
                if (hasInput && suggestedSearchesLoading) {
                    setPressedEnter(true);
                    return;
                }
                var suggestion = highlightedSuggestion ||
                    suggestionResults[0] ||
                    constants_1.noSelectedSuggestion;
                // Save Suggested Search to Local Storage
                if (suggestion.searchType === constants_1.SearchType.TextSearch) {
                    setRecentSearches((0, suggestions_1.saveSuggestionToLocalStorage)(suggestion));
                }
                var eventData = getSuggestionEventData(suggestion);
                searchBarEvents.pressedEnter(eventData);
                handleSuggestionSelection((0, utils_1.normalizeSuggestionSelection)(suggestion), eventData);
                return;
            case 'ArrowUp':
                if (highlightedIndex === -1)
                    return;
                currentSelection = highlightedIndex - 1;
                setHighlightedIndex(currentSelection);
                if ((_a = suggestionResults[currentSelection]) === null || _a === void 0 ? void 0 : _a.text) {
                    setDisplayInputValue(suggestionResults[currentSelection].text);
                }
                else {
                    setDisplayInputValue(suggestionQuery);
                }
                break;
            case 'ArrowDown':
                currentSelection = highlightedIndex + 1;
                if (currentSelection === suggestionResults.length) {
                    return;
                }
                setHighlightedIndex(currentSelection);
                if ((_b = suggestionResults[currentSelection]) === null || _b === void 0 ? void 0 : _b.text) {
                    setDisplayInputValue(suggestionResults[currentSelection].text);
                }
                else {
                    setDisplayInputValue(suggestionQuery);
                }
                break;
            default:
                break;
        }
    }, [
        displayInputValue.length,
        getSuggestionEventData,
        handleSuggestionSelection,
        hasInput,
        highlightedIndex,
        highlightedSuggestion,
        searchBarEvents,
        setDisplayInputValue,
        setKeyPressed,
        setRecentSearches,
        suggestedSearchesLoading,
        suggestionQuery,
        suggestionResults
    ]);
    return (0, react_1.useMemo)(function () { return ({
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        getMenuProps: getMenuProps,
        handleClearText: handleClearText,
        handleDefaultSuggestionClicked: handleDefaultSuggestionClicked,
        handleInputOnChange: handleInputOnChange,
        handleInputOnFocus: handleInputOnFocus,
        handleKeyDown: handleKeyDown,
        handleGoButtonClick: handleGoButtonClick,
        handleRemoveRecentSearch: handleRemoveRecentSearch,
        handleSuggestionClick: handleSuggestionClick,
        hasInput: hasInput,
        hasSuggestionQuery: suggestionQuery.length > 0,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        noResultsQuery: noResultsQuery,
        setHighlightedIndex: setHighlightedIndex,
        suggestionResults: suggestionResults
    }); }, [
        getInputProps,
        getItemProps,
        getMenuProps,
        handleClearText,
        handleDefaultSuggestionClicked,
        handleGoButtonClick,
        handleInputOnChange,
        handleInputOnFocus,
        handleKeyDown,
        handleRemoveRecentSearch,
        handleSuggestionClick,
        hasInput,
        highlightedIndex,
        isOpen,
        noResultsQuery,
        suggestionQuery.length,
        suggestionResults
    ]);
}
exports.default = useSearchBar;
//# sourceMappingURL=useSearchBar.js.map